<tt-page *ngIf="page">
    <tt-card>
        <tt-tabs [ttSelectedId]="filters.state" (ttSelectedIdChange)="changeState($event)">
            <tt-tab ttId="ACT" ttLabel="active"></tt-tab><tt-tab ttId="NOT_ACT" ttLabel="not_active"></tt-tab><tt-tab ttId="ALL" ttLabel="all"></tt-tab>
        </tt-tabs>
        <tt-tabs [ttSelectedId]="filters.category" (ttSelectedIdChange)="changeCategory($event)">
            <tt-tab ttId="i" ttLabel="internal_users"></tt-tab><tt-tab ttId="e" ttLabel="external_users"></tt-tab>
        </tt-tabs>
        <tt-tabs *ngIf="filters.category === 'i'" [ttSelectedId]="filters.type" (ttSelectedIdChange)="changeType($event)">
            <tt-tab ttId="L" ttLabel="labours"></tt-tab><tt-tab ttId="T" ttLabel="terminals"></tt-tab>
        </tt-tabs>
        <tt-tabs *ngIf="filters.category === 'e'" [ttSelectedId]="filters.role" (ttSelectedIdChange)="changeRole($event)">
            <tt-tab ttId="S" ttLabel="suppliers"></tt-tab><tt-tab ttId="C" ttLabel="customers"></tt-tab>
        </tt-tabs>
        <form (ngSubmit)="search()">
            <tt-input ttLabel="filtervalue" [ttModel]="page.filtervalue" (ttModelChange)="changeSearch($event)">
                <ng-container buttons>
                    <!-- Erase remembers and reloads even when the filter is already empty. -->
                    <tt-form-field-button ttId="erase" ttIcon="fas fa-eraser" ttType="danger" (ttClick)="clearSearch()"></tt-form-field-button>
                    <tt-form-field-button ttId="search" [ttIcon]="loading ? 'fas fa-spinner fa-spin' : 'fas fa-search'" [ttDisabled]="loading" (ttClick)="search()"></tt-form-field-button>
                </ng-container>
            </tt-input>
        </form>
    </tt-card>
    <tt-list [ttData]="items" [ttGoto]="false" [ttButtons]="rowButtons" (ttClick)="open($event)"></tt-list>
</tt-page>
<p *ngIf="error" role="alert">{{ error }}</p>
